import { clamp } from '@Utils/Math.js'

export function createCanvas(width, height, tag) {
	if (typeof document === 'undefined') {
		let c = new OffscreenCanvas(width, height)
		c.oncontextlost = function (event) {
			console.error(`${tag}: context lost`)
		}
		c.oncontextrestored = function (event) {
			console.info(`${tag}: context restored`)
		}
		return c
	}
	let c = document.createElement('canvas')
	c.width = width
	c.height = height
	return c
}
export function createContext(width, height, tag) {
	let canvas = createCanvas(width, height, tag)
	let context = getContext(canvas)
	return [canvas, context]
}
export function getContext(canvas, tag) {
	let context = canvas.getContext('2d', {
		desynchronized: true,
		//preserveDrawingBuffer: true,
		willReadFrequently: true,
		// imageSmoothingEnabled: true,
		// imageSmoothingQuality: 'high'
	})
	if (tag) {
		canvas.oncontextlost = function (event) {
			console.error(`${tag}: context lost`)
		}
		canvas.oncontextrestored = function (event) {
			console.info(`${tag}: context restored`)
		}
	}
	canvas.imageSmoothingQuality = 'high'
	return context
}
export function createCanvasFromImageData(data) {
	let canvas = createCanvas(data.width, data.height, 'Canvas.createCanvasFromImageData')
	let context = getContext(canvas)
	context.putImageData(data, 0, 0)
	return canvas
}
export function createPath(coordinates) {
	let path = new Path2D()
	path.moveTo(coordinates[0][0], coordinates[0][1])
	for (let i = 1; i < coordinates.length; i++) {
		path.lineTo(coordinates[i][0], coordinates[i][1])
	}
	return path
}
export function display(options) {
	if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
		return
	}
	if (!options) {
		return
	}
	if (options['getContext']) {
		document.body.appendChild(options)
	} else if (options.canvas) {
		document.body.appendChild(options.canvas)
	} else if (options.imageData) {
		let canvas = createCanvas(options.imageData.width, options.imageData.height)
		let context = canvas.getContext('2d')
		context.putImageData(options.imageData, 0, 0)
		document.body.appendChild(canvas)
	}
}
export function getPixel(imageData, x, y, def = [128, 128, 128, 255]) {
	if (!imageData) {
		return def
	}
	x = clamp(Math.floor(x), 0, imageData.width)
	y = clamp(Math.floor(y), 0, imageData.height)
	const offset = y * imageData.width * 4 + x * 4
	return [imageData.data[offset + 0], imageData.data[offset + 1], imageData.data[offset + 2], imageData.data[offset + 3]]
}

export async function addLine(context, coordinates) {
	if (coordinates.length < 1) {
		return
	}
	context.moveTo(coordinates[0][0], coordinates[0][1])
	for (let i = 1; i < coordinates.length; i++) {
		context.lineTo(coordinates[i][0], coordinates[i][1])
	}
}
let conversionCanvas = new OffscreenCanvas(100, 100)
let conversionContext = conversionCanvas.getContext('bitmaprenderer', {
	//desynchronized: true
})
export async function convertToBlob({
	image,
	type = 'image/jpeg',
	quality = 0.7
}, tag) {
	// if (tag) {
	// 	console.log(`Canvas.convertToBlob: ${tag}`)
	// }
	conversionCanvas.width = image.width
	conversionCanvas.height = image.height
	conversionContext.transferFromImageBitmap(image)
	return await conversionCanvas.convertToBlob({ type: type, quality: quality })
}
export async function convertCanvasToBlob(canvas, options = {
	type: 'image/jpeg',
	quality: 0.7
}, tag) {
	//console.log(`Canvas.convertCanvasToBlob: ${tag}`)
	return new Promise((resolve, reject) => {
		canvas.toBlob(function (blob) {
			resolve(blob)
		}, options.type, options.quality)
	})
}